import { SyncOutlined } from '@ant-design/icons';
import Button from 'antd/lib/button';
import React, { useContext } from 'react';
import { ISite } from '../../../../domain/site/interface';
import { EnergyUsageSidebarFiltersContext, IEnergyUsageSidebarFiltersContext } from '../context/EnergyUsageSidebarFiltersContext';
import { EnergyUsageSidebarSitesTabs } from '../sites-selecting/EnergyUsageSidebarSitesTabs';

interface ISitesPanelProps {
    collapsed: boolean;
    isChartsDataLoading: boolean;
    onLoadData: (siteIds: number[], sites: ISite[]) => void;
    onCollapseChange: (value: boolean) => void;
}

export const SitesPanel: React.FC<ISitesPanelProps> = ({ collapsed, isChartsDataLoading, onLoadData, onCollapseChange }) => {
    const { selectedSiteOptions } = useContext<IEnergyUsageSidebarFiltersContext>(EnergyUsageSidebarFiltersContext);

    const handleLoadData = () => {
        const selectedSites = selectedSiteOptions.map(option => option.site);

        onLoadData(
            selectedSites.map(site => site.site_id),
            selectedSites
        );
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%',
            }}
        >
            <EnergyUsageSidebarSitesTabs collapsed={collapsed} />

            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px', borderTop: '1px solid #d9d9d9' }}>
                <Button
                    type="primary"
                    color="primary"
                    size="middle"
                    icon={<SyncOutlined />}
                    loading={isChartsDataLoading}
                    onClick={handleLoadData}
                    disabled={selectedSiteOptions.length === 0}
                >
                    Load Data
                </Button>
            </div>
        </div>
    );
};
